module.exports = (__webpack_require__("dll-reference mdfCore"))("./dist/esm/index.mjs");